export interface OnComponentDidMount {
    (): void;
}

export var onComponentDidMount: OnComponentDidMount;
